import styled from "styled-components";

export const StyledLink = styled.a`
    color: ${({ theme }) => theme.colors.black};
    font-size: 14px;
    &:link,
    &:visited,
    &:hover,
    &:active {
        color: ${({ theme }) => theme.colors.black};
        cursor: pointer;
        text-decoration: none;
    }
`;
